export const enum Sizes {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
}

export const TOUCH_TARGET = 44
